import React from 'react';
import { Skeleton } from '@perch-labs/shrike';
import { Container } from 'styles';

export const Loading = () => (
  <Container padding="24px" data-testid="loading">
    <Skeleton backgroundColor="tertiary" opacity="low" height="20px" />
    <Skeleton
      backgroundColor="tertiary"
      opacity="low"
      height="30px"
      width="100%"
    />
    <Skeleton backgroundColor="tertiary" opacity="low" height="20px" />
  </Container>
);
